import axios from 'axios'
import store from '../store'
import router from '../router'
import { MessageBox } from 'element-ui'
import moment from 'moment'
import { itemscollection, chartdatagroup, chartdatatimes, activecollection, renewitems, renewcollection, chartdataxy } from "@/components/utility/indexdb";
// //tomakeurl主用于formuladata
import { hrefinfotostore, generateurl, tomakeurl } from './objparamobj'
import { fetchdata } from './fetchdata'
import clctinitial from "./clctinitial"//{fetchheader,authset,clctinitiate}
import { appinitial, searchfromurl } from "./appinitial"


axios.generateurl = generateurl
axios.fetchdata = fetchdata
axios.clctinitial = clctinitial
axios.appinitial = appinitial
axios.searchfromurl = searchfromurl

// 拦截请求
axios.interceptors.request.use((config) => {


  let expireTime = store.state.expireTime

  //alert(expireTime)

  let now = moment().format('YYYYMMDDHHmmss')
  //让token早10秒种过期，提升“请重新登录”弹窗体验
  if(router.currentRoute.path!="/login"){
    if (expireTime && (expireTime - now < 10)) {//expireTime-now<10
      store.commit("process", false)
      MessageBox({
        title: '登录已过期',
        message: '登录已过期，请重新登录',
        callback: () => {
          //return new Promise((resolve, reject) => {
          localStorage.clear()
          itemscollection.remove({})
          router.push('/login')
          //location.reload()
          //})
        }
      })
      return false
    }
  }


  setTimeout(function () { if (store.state.loading) { store.commit("setloading", false) } }, 3000)//如果3000ms无反应，那么放弃loading

  //带上token
  if (store.state.token) {
    config.headers.Authorization = store.state.token
    //是否现实loading状态
    if (config.data && config.data.loadingstatus != "none") {
      store.commit("setloading", true)
    }
  }
  return config
  // }

}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
axios.interceptors.response.use((config) => {
  // store.commit("setloading", false)
  setTimeout(() => { store.commit("setloading", false) }, 50)
  //对tabledata中的dataformula进行处理
  if (config.data.datamodel == "tabledata") {
    let doc = config.data.doc
    let fields = config.data.fields
    let datas = formuladata(doc, fields, tomakeurl)
    // .then(datas=>{
    config.data.doc = datas
    return config
    // })
  }
  //对aggregateclct中的dataformula进行处理
  if (config.config.url.includes("aggregateclct")) {// console.log("xxxxx")
    for (let key in config.data) {
      let doc = config.data[key].doc
      let fields = config.data[key].fields
      let datas = formuladata(doc, fields, tomakeurl)
      config.data[key].doc = datas
    }
    return config
  }

  return config

}, (error) => { })

//根据header dataformula data
function formuladata(datas, fields, tomakeurl) {
  // return new Promise((resolve,reject)=>{
  fields.forEach(obj => {
    if (obj.name == "dataformula") {
      datas.forEach(data => {
        eval(obj.theformula)
      })
    }
  })
  return datas
  // })

}





axios.dologin = function (formdata) {
  
  return new Promise((resolve, reject) => {
   
    axios.post(url + "login", formdata)
      .then((r) => {
      
        let data = r.data
        if (data === "failed") {
          console.log("failed")
          resolve("failed")
        }
        else if (data === "relogin") {
          console.log("relogin")
          resolve("relogin")
        }
        else {
          console.log("login success")
          store.commit("setToken", data.token)
          store.commit("setExpireTime", data.exipreTime)
          store.commit("setUser", data.user)
          // store.commit("setPermissions", data.permissions)
          store.commit("setWeight", data.weight)
          store.commit("setUserRoles", data.roles)
          store.commit("setCommunity",data.community)
          resolve("success")


        }

      }).catch(() => {

      })


  })

}

axios.getcollections = function () {
  return new Promise(resolve => {
    axios.get(url + "getcollections").then(res => {
      console.log("remote fetch collections");
      store.commit("setcollections", res.data);
      resolve(res.data)
    });
  })

}





axios.fetchremotechartdata = function (chartmodel, skipno) {
  return new Promise(resolve => {
    let chartquery = {
      matchrule: store.state.matchrule,
      searchmodel: store.state.searchmodel,
      chartmodel: chartmodel,
      collection: store.state.collection.value,
      fdata: store.state.filter,
      target: store.state.targettxt,
      ids: store.state.fetchids,
      xfield: store.state.xfield,
      timemodel: store.state.timemodel,
      yvalues: store.state.yvalues,
      page: store.state.page,
      skipno: skipno//用于通知需要sikp的数量
    };


    axios.post(url + "remotechartdata", chartquery).then(res => {
      //用于判断chart是否显示完整

      if (res.data.length < store.state.datainformation.perpage) {
        store.commit("setchartdatanomore", true)
      }
      else {
        store.commit("setchartdatanomore", false)
      }


      let currentdata = store.state.chartdataxy
      store.commit("setifremotechart", true)
      store.commit("setchartmodel", chartmodel)
      if (skipno) {
        store.commit("setchartdataxy", currentdata.concat(res.data));
      }
      else {
        store.commit("setchartdataxy", res.data);
      }

      if (chartmodel === "time") {
        chartdatatimes(chartquery.xfield, chartquery.yvalues, store.state.chartdataxy)
      }

      if (chartmodel === "group") {
        chartdatagroup(chartquery.xfield, chartquery.yvalues, store.state.chartdataxy)

      }


    });


  })
}


axios.downloadpdf = function (username, printintheclct, printitems) {
  return new Promise(resolve => {
    let receivers = printitems[0].receivers
    let data = {};
    // data.collection = this.$store.state.clct + this.clctto;
    data.collection = printintheclct
    data.items = printitems;
    data.name = username;
    data.receivers = receivers
    axios
      .post(url + "downloadpdf", data, { responseType: "blob" })
      .then(res => {
        console.log(res.headers.filename)
        let url = URL.createObjectURL(res.data);
        let link = document.createElement("a");
        link.download = res.headers.filename //moment().format("YYYYMMDDHHmmss") + ".pdf";
        link.href = url;
        link.click();
        resolve("downloaded")
        // this.downloaded = true;
      });
  })

}

axios.thedatatopdf = function () {
  return new Promise(resolve => {
    //将filter中的null值删除
    let fdata = JSON.parse(JSON.stringify(store.state.filter))
    for (let key in fdata) {
      if (fdata[key] === null) {
        delete fdata[key]
      }
    }
    let query = {
      name: store.state.user,
      searchmodel: store.state.searchmodel,
      collection: store.state.collection.value,
      fdata: fdata,
      target: store.state.targettxt,
      ids: store.state.fetchids
    }


    axios
      .post(url + "thedatatopdf", query, { responseType: "blob" })
      .then(res => {
        console.log(res.headers.filename)
        let url = URL.createObjectURL(res.data);
        let link = document.createElement("a");
        link.download = res.headers.filename //moment().format("YYYYMMDDHHmmss") + ".pdf";
        link.href = url;
        link.click();
        resolve("downloaded")
        // this.downloaded = true;
      });
  })
}

axios.jumptoclct = function ({ collection, model, value, target }) {
  axios.clctinitial.clctinitiate(collection.value).then(header => {
    if (model === "filter") {
      store.commit("setsearchmodel", "filter");
      header.forEach(obj => {
        if (obj.name === target) {
          store.commit("setxfield", target);
          let thefilter = {};
          thefilter[target] = value + "";
          store.commit("setfilter", thefilter);
        }
      });
    }
    if (model === "generalsearch") {
      store.commit("setsearchmodel", "generalsearch");
      store.commit("settargettxt", value);
    }

    store.commit("setpage", 1);
    axios.fetchdata();
  });
  //this.targetchanged(obj.value)
  // this.popupposition.display = "none";
}






export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js